import BaseService from './BaseService'
export interface ISyncAttachmentsBody{
  contactId:string
  locationId:string
  sourceId:string
  attachments:string[]
  attachmentType:DocumentsAttachmentType
  channel?:string
}

export enum DocumentsAttachmentType {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound'
}

class DocumentService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  upload = (params,file) =>
    this.requests.post(
      `/upload?locationId=${params.locationId}&contactId=${params.contactId}&customFieldId=${params.customFieldId}&folderKey=${params.folderKey}`,
      file
    )
   async  syncAttachments(body:ISyncAttachmentsBody){
      return this.requests.post(`/syncAttachments`,body)
  }

}

const instance = new DocumentService(BaseService.servicesConfig.Documents)

export default instance
